import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Bemidji",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Bemidji Minnesota north woods lake city, beautiful Lake Bemidji with the iconic Paul Bunyan and Babe the Blue Ox statue visible along the waterfront, Bemidji State University campus along the lake shore, historic downtown with the statues and waterfront park, surrounded by dense north woods forest, Mississippi River headwaters visible, clear blue lake water reflecting summer sky, pine and birch trees, professional aerial photography, no readable signs or text",
  heroImageSeq: "bemidji-mn-hero-2026",
  heroDescription:
    "Canadian fishing trip to Lake of the Woods in three weeks and your passport expired? European study abroad at Bemidji State with six weeks to spare? Ojibwe cultural heritage trip to Canada with a month notice? We help Bemidji residents — from Bemidji State University students and Red Lake Nation community members to north woods outdoor enthusiasts and lake resort families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "47.4716; -94.8803",
  geoPlacename: "Bemidji, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/bemidji/",
  localAreaTitle: "Serving Bemidji & the North Woods Lake Region",
  localAreaText: [
    "Bemidji, Minnesota is the largest city in north central Minnesota and the self-proclaimed 'First City on the Mississippi' — the Mississippi River begins its 2,300-mile journey at Lake Itasca, just 25 miles north of Bemidji. The city is the county seat of Beltrami County and serves as the cultural, educational, and commercial hub for a vast region that includes the Red Lake Nation, Leech Lake Reservation, and the Boundary Waters.",
    "Bemidji State University, located on the shores of Lake Bemidji, anchors the city's educational identity with programs that draw students from across the Upper Midwest and beyond. The university maintains international partnerships and study abroad programs, creating a steady flow of passport needs from students and faculty. The city's location near three tribal nations (Red Lake, Leech Lake, and White Earth) creates a unique cultural landscape where indigenous heritage, international education, and outdoor recreation intersect.",
    "The city is famous for its iconic Paul Bunyan and Babe the Blue Ox statues on the waterfront, which have welcomed visitors since 1937. Lake Bemidji provides year-round recreation, from summer fishing and boating to winter ice fishing and snowmobiling. The surrounding north woods region offers some of Minnesota's most pristine wilderness, including Itasca State Park, the headwaters of the Mississippi, and the Boundary Waters Canoe Area.",
    "Bemidji's location near the Canadian border (about 80 miles north) creates unique travel patterns. Residents frequently cross into Canada for fishing, hunting, and recreation. The city's proximity to International Falls and Fort Frances, Ontario, makes Canadian travel a natural extension of the north woods lifestyle. The combination of university students, tribal community members, outdoor enthusiasts, and seasonal residents creates diverse international travel needs.",
  ],
  nearbyCities: [
    { name: "Bemidji", zips: "56601" },
    { name: "Bagley", zips: "56621" },
    { name: "Blackduck", zips: "56630" },
    { name: "Cass Lake", zips: "56633" },
    { name: "Park Rapids", zips: "56470" },
    { name: "Red Lake", zips: "56671" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Bemidji home or cabin in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Bemidji area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Bemidji & North Central Minnesota Lake Country",
  serviceAreaDescription: "Serving Beltrami County and north central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Bemidji, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Bemidji area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Bemidji State University students get passports before study abroad?",
      a: "Absolutely. We regularly process expedited renewals and new applications for Bemidji State students preparing for international programs in Europe, Asia, and Canada. We understand the academic timeline pressures.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Bemidji?",
      a: "No — most Bemidji travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Bemidji. You can ship from FedEx or UPS locations nearby.",
    },
    {
      q: "My family is planning a Canadian fishing trip. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Canadian fishing is a core part of the north woods lifestyle.",
    },
    {
      q: "What if I need a passport for a last-minute Canadian hunting trip?",
      a: "Canadian hunting trips are often planned with short notice when the season opens. We can process your passport as fast as 24 hours with proof of travel. Our emergency service is designed for exactly these situations.",
    },
    {
      q: "Are there passport acceptance facilities near Bemidji?",
      a: "The Bemidji Post Office, Cass Lake Post Office, and Bagley Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "The Whitebird Family",
      location: "Bemidji, MN",
      rating: 5,
      text: "We planned a Canadian fishing trip to Lake of the Woods with our neighbors and discovered my passport had expired two weeks before we were supposed to leave. Fast Passport Center processed my renewal in four business days. We made our trip and had the best fishing of the season. Thank you for saving our north woods tradition.",
      service: "Emergency Renewal",
    },
    {
      name: "Jake T.",
      location: "Bemidji, MN",
      rating: 5,
      text: "I'm a Bemidji State student studying abroad in Norway next semester. I discovered my passport had expired with only three weeks before departure. Fast Passport Center processed my renewal in four business days. I made my program and had an incredible semester in Scandinavia. The checklist was so helpful.",
      service: "Student Renewal",
    },
    {
      name: "The Redsky Family",
      location: "Bemidji, MN",
      rating: 5,
      text: "We planned a family heritage trip to visit relatives in Canada with our extended family. Four passports needed renewal. Fast Passport Center processed everything in six business days. The team was respectful and professional. We had a wonderful reunion with our Canadian relatives.",
      service: "Family Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Brainerd", href: "/cities/brainerd" },
    { name: "Duluth", href: "/cities/duluth-mn" },
    { name: "St. Cloud", href: "/cities/st-cloud" },
    { name: "Moorhead", href: "/cities/moorhead" },
    { name: "Fargo", href: "/cities/fargo" },
    { name: "Grand Rapids", href: "/cities/grand-rapids" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Bemidji",
  introDescription: "Fast passport processing for Bemidji and north central Minnesota lake country travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Bemidji and north central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Bemidji Post Office",
      address: "3400 Industrial Blvd SE, Bemidji, MN 56601",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(218) 751-3935",
      notes: "Primary passport acceptance facility for Bemidji and Beltrami County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Cass Lake Post Office",
      address: "221 4th St NW, Cass Lake, MN 56633",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(218) 335-2244",
      notes: "Cass County. Full passport services. Convenient for east Bemidji residents.",
    },
    {
      name: "Bagley Post Office",
      address: "22 Main Ave N, Bagley, MN 56621",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(218) 694-6241",
      notes: "Clearwater County. Full passport services. Convenient for west Bemidji residents.",
    },
    {
      name: "Park Rapids Post Office",
      address: "120 W 2nd St, Park Rapids, MN 56470",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(218) 732-4457",
      notes: "Hubbard County. Full passport services. Convenient for south Bemidji residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Bemidji", address: "Bemidji commercial area", hours: "Call for hours" },
    { name: "CVS Pharmacy — Bemidji", address: "Bemidji commercial area", hours: "Daily 7 AM – 10 PM" },
    { name: "Walmart — Bemidji", address: "Bemidji commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Bemidji", address: "Bemidji commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Beltrami County DVS Office",
      address: "Bemidji, MN area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Beltrami County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Cass Lake DVS Office",
      address: "Cass Lake, MN area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Cass County DVS. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BJI",
      name: "Bemidji Regional Airport",
      distance: "About 5 miles from Bemidji — 10 minutes by car",
      address: "3824 Ardenwood Dr SE, Bemidji, MN 56601",
      note: "Regional airport for Bemidji residents. Direct flights to Minneapolis. No commercial international service.",
      flightUrl: "https://www.bemidjiairport.com/",
      flightLabel: "Bemidji Regional Airport",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 215 miles from Bemidji — 3.5 hours by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international airport for Bemidji residents. Full international flight service. Access via Highway 2 and I-94.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
    {
      code: "DLH",
      name: "Duluth International Airport",
      distance: "About 150 miles from Bemidji — 2.5 hours by car",
      address: "4701 Grinden Dr, Duluth, MN 55811",
      note: "Regional airport for Bemidji residents. Direct flights to Chicago, Minneapolis, and Denver. International connections.",
      flightUrl: "https://www.duluthairport.com/",
      flightLabel: "Duluth International Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Canadian Fishing & Outdoor Travel",
      subtitle: "North woods families planning Canadian fishing trips and hunting expeditions",
      content:
        "Bemidji and the north woods region is the gateway to Canadian outdoor adventures. Lake families regularly plan fishing trips to Ontario, Manitoba, and Lake of the Woods. Canadian hunting expeditions are also common. These trips are often planned when conditions are right — sometimes with only 2–3 weeks notice.",
      tip: "Canadian fishing trips are common spring through fall. A passport card works for land and sea crossings to Canada. Keep yours current.",
      icon: "ri-ship-line",
    },
    {
      title: "Winter Caribbean & Mexico Escapes",
      subtitle: "North woods families escaping Minnesota winters for warm destinations",
      content:
        "Bemidji residents often plan Caribbean cruises and Mexico resort vacations during the winter off-season. These trips are booked during fall and early winter, with departure dates typically in January through March. The extreme north woods winters make warm destinations especially appealing.",
      tip: "Winter Caribbean trips are common January through March. Check passport validity in October for winter travel.",
      icon: "ri-sun-line",
    },
    {
      title: "Study Abroad & Academic Travel",
      subtitle: "Bemidji State University students with international programs",
      content:
        "Bemidji State University maintains international partnerships and study abroad programs in Europe, Canada, and beyond. Students often discover passport issues during pre-departure orientation. The university's location in the north woods creates a unique blend of academic and outdoor cultures.",
      tip: "Study abroad deadlines are non-negotiable. Start your passport renewal the moment you are accepted into a program.",
      icon: "ri-book-open-line",
    },
    {
      title: "Indigenous Heritage & Cultural Travel",
      subtitle: "Red Lake, Leech Lake, and White Earth community members with international connections",
      content:
        "Bemidji's proximity to three tribal nations creates unique cultural travel patterns. Community members travel for international cultural exchanges, conferences, and family visits. The Ojibwe cultural heritage and international indigenous connections create meaningful travel opportunities.",
      tip: "Cultural travel often has specific dates for conferences and events. Start passport renewals early.",
      icon: "ri-earth-line",
    },
  ],
  destinations: [
    {
      name: "Canada",
      context: "Fishing and hunting trips to Ontario, Manitoba, and Lake of the Woods for north woods families",
      urgency: "Canadian trips are often planned when conditions are right — passport must be current",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway",
      context: "Scandinavian heritage trips and study abroad for Bemidji State students",
      urgency: "Semester programs and heritage trips have strict timelines",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises and all-inclusive resorts for winter escapes from the north woods",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Resort vacations for north woods families during winter and spring break",
      urgency: "Resort packages are often booked 3–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Sweden",
      context: "Scandinavian heritage and cultural exchange for the north woods community",
      urgency: "Heritage trips are often planned 6+ months in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "European travel and cultural exchange for students and community members",
      urgency: "European trips and conferences have specific dates",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "40%", label: "of Bemidji expedited requests are Canadian fishing trips with weather-dependent timing" },
    { stat: "3–4 Weeks", label: "most common advance notice when north woods families discover passport issues before a trip" },
    { stat: "Nov–Mar", label: "peak travel season for Caribbean escapes and winter warm-weather trips" },
    { stat: "5–7 Days", label: "typical expedited processing time for Bemidji clients choosing our recommended option" },
  ],
};

export default function BemidjiMNPage() {
  return <CityPage data={data} />;
}